// src/data/productsData.js
const productsData = [
  {
    id: '1',
    sku: 'MUP3366-M86',
    title: 'Mens Vertical Stripe Knit Polo Shirt',
    description: 'An elevated take on a smart-casual staple, the U.S. Polo Assn. mens Vertical Stripe Knit Polo Shirt combines timeless style with comfort. Crafted from a soft, luxe cotton blend, it features rib trims and a sophisticated knitted vertical stripe design. Pair with chinos and layer under a jacket for a refined look, or wear with sweats for relaxed, off-duty style.',
    category: 'Mens',
    quality: '53% Modal 47% Cotton',
    highlights: [
      'Soft cotton blend: Comfortable and breathable fabric',
      'Vertical stripe design: Adds a polished, modern touch',
      'Signature logo: Embroidered double Horsemen logo on chest',
      'Ribbed trims: Enhances fit and shape'],
    image: require('../../../image/Our_product/MUP3366/MUP3366-M86-MS_1.webp'),
    images: [
      require('../../../image/Our_product/MUP3366/MUP3366-M86-MS_1.webp'),
      require('../../../image/Our_product/MUP3366/MUP3366-M86-MS_2.webp'),
      require('../../../image/Our_product/MUP3366/MUP3366-M86-MS_3.webp'),
      require('../../../image/Our_product/MUP3366/MUP3366-J09-MS_4.webp'),
      require('../../../image/Our_product/MUP3366/MUP3366-J09-MS_5.webp')]
  },
  {
    id: '2',
    sku: 'MUP3992-M86',
    title: 'Mens Stripe Textured Zip Polo Shirt',
    description: 'Elevate your smart-casual wardrobe with the mens Stripe Textured Zip Polo Shirt, a modern piece that merges timeless style with contemporary detailing. Crafted from a textured fabric with vertical stripes, this polo brings a touch of sophistication and depth to any look. Pair with chinos and loafers for an effortlessly refined style, or wear with jeans and trainers for a versatile, polished look.',
    category: 'Mens',
    quality: '70% Polyester 30% Cotton',
    highlights: [
      'Vertical stripe texture – Adds dimension and elegance to the design',
      'High-shine chrome zip – A modern twist on a classic polo closure',
      'Signature logo: Embroidered double Horsemen logo on chest',
      'Textured rib collar and cuffs – Offers a refined, elevated touch'],
    image: require('../../../image/Our_product/MUP3992/MUP3992-981-MS_4.webp'),
    images: [
      require('../../../image/Our_product/MUP3992/MUP3992-H03-MS_1.webp'),
      require('../../../image/Our_product/MUP3992/MUP3992-H03-MS_2.webp'),
      require('../../../image/Our_product/MUP3992/MUP3992-H03-PS_3.webp'),
      require('../../../image/Our_product/MUP3992/MUP3992-981-MS_4.webp'),
      require('../../../image/Our_product/MUP3992/MUP3992-981-PS_5.webp'),]
  },
  {
    id: '3',
    sku: 'WUP1377-L68',
    title: 'Womens Stripe Loose Cable Knit Cardigan',
    description: 'Indulge in timeless elegance with the U.S. Polo Assn. Womens Stripe Loose Cable Knit Cardigan. This relaxed, open-front style beautifully combines modern comfort with heritage charm, making it a versatile layer for any season. Pair it with denim or chinos for a sophisticated yet effortless look.',
    category: 'Womens',
    quality: '100% Cotton',
    highlights: [
      'Classic cable knit adds texture and refinement',
      'Open front design for easy layering',
      'Branded horn buttons for a touch of sophistication',
      'Viscose blend for soft, lasting comfort'],
    image: require('../../../image/Our_product/WUP1377/WUP1377-L68-MS_1.webp'),
    images: [
      require('../../../image/Our_product/WUP1377/WUP1377-L68-MS_1.webp'),
      require('../../../image/Our_product/WUP1377/WUP1377-L68-MS_2.webp'),
      require('../../../image/Our_product/WUP1377/WUP1377-L68-PS_3.webp'),
      require('../../../image/Our_product/WUP1377/WUP1377-L68-PS_4.webp'),
      require('../../../image/Our_product/WUP1377/WUP1377-L68-PS_5.webp'),]
  },
  {
    id: '4',
    sku: 'USG0350-879',
    title: 'Fair ISLE Cardigan Marshmallow',
    description: 'Girls Fair Isle Cardigan epitomises classic elegance with a touch of heritage charm. Crafted from luxury yarns for an exceptionally soft handfeel, this cardigan features an intarsia Fair Isle knit with intricate float stitches, adding a sophisticated texture. Perfect for layering, this cardigan effortlessly pairs with jeans or skirts for versatile styling.',
    category: 'Girls',
    quality: '80% ACRYLIC, 20% NYLON',
    highlights: [
      'Intarsia Fair Isle knit for a timeless design',
      'Relaxed fit with drop shoulder design for comfort',
      'Double rib mock neck, hem, and cuffs for a refined finish',
      'Embroidered double horsemen motif at the hem'],
    image: require('../../../image/Our_product/USG0350/USG0350-879-MS_1.webp'),
    images: [
      require('../../../image/Our_product/USG0350/USG0350-879-MS_1.webp'),
      require('../../../image/Our_product/USG0350/USG0350-879-MS_2.webp'),
      require('../../../image/Our_product/USG0350/USG0350-879-MS_3.webp'),
      require('../../../image/Our_product/USG0350/USG0350-879-MS_4.webp'),
      require('../../../image/Our_product/USG0350/USG0350-879-MS_5.webp')]
  },
  {
    id: '5',
    sku: 'USG0388-G81',
    title: 'Stripe Crew Jumper Midnight Blue',
    description: 'Girls Stripe Crew Jumper combines timeless style with luxurious comfort. Crafted from the finest quality yarns, this jumper features a relaxed fit and classic horizontal stripes, making it a chic addition to any wardrobe. Ideal for layering over jeans or a skirt, this jumper effortlessly elevates everyday outfits.',
    category: 'Girls',
    quality: '83% Viscose 15% Nylon 2% Elastane',
    highlights: [
      'Luxurious yarns for exceptional comfort',
      'Double self-yarn rib at neck, hem, and cuffs for durability',
      'Classic horizontal stripe design',
      'Embroidered double horsemen motif on the chest'],
    image: require('../../../image/Our_product/USG0388/USG0388-G81-MS_1.webp'),
    images: [
      require('../../../image/Our_product/USG0388/USG0388-G81-MS_1.webp'),
      require('../../../image/Our_product/USG0388/USG0388-G81-MS_2.webp'),
      require('../../../image/Our_product/USG0388/USG0388-G81-MS_3.webp'),
      require('../../../image/Our_product/USG0388/USG0388-G81-MS_4.webp'),
      require('../../../image/Our_product/USG0388/USG0388-G81-MS_5.webp')]
  },
  {
    id: '6',
    sku: 'MUP4110-M84',
    title: 'Mens Crochet Knit Open Collar Polo Shirt in Doeskin',
    description: 'Exude relaxed sophistication with the U.S. Polo Assn. Mens Crochet Knit Open Collar Polo Shirt. This refined staple blends timeless style with a unique crochet texture, creating a perfect piece for versatile smart-casual looks. Wear it with tailored trousers for a polished ensemble or pair it with chinos for effortless, off-duty style.',
    category: 'Mens',
    quality: '100% Cotton',
    highlights: [
      'Unique Crochet Texture: Adds a distinct look and tactile appeal',
      'Open Collar Design: Offers a laid-back yet polished silhouette',
      '100% Cotton Construction: Provides soft, breathable comfort',
      'Signature Double Horsemen Logo: Embroidered for brand authenticity'],
    image: require('../../../image/Our_product/MUP4110/MUP4110-M84-MS_1.webp'),
    images: [
      require('../../../image/Our_product/MUP4110/MUP4110-M84-MS_1.webp'),
      require('../../../image/Our_product/MUP4110/MUP4110-M84-MS_2.webp'),
      require('../../../image/Our_product/MUP4110/MUP4110-M84-MS_3.webp'),
      require('../../../image/Our_product/MUP4110/MUP4110-M84-MS_4.webp'),
      require('../../../image/Our_product/MUP4110/MUP4110-M84-MS_5.webp'),]
  },
  {
    id: '7',
    sku: 'USP2672-G92',
    title: 'Boys Combed Cotton Polo Shirt',
    description: 'Crafted from combed cotton, this U.S. Polo Assn. Boys Polo Shirt combines classic style with a soft, comfortable feel. Perfect for any occasion, it pairs effortlessly with jeans or chinos for a polished look.',
    category: 'Boys',
    quality: '100% Cotton',
    highlights: [
      'Combed cotton: Provides a soft, premium feel',
      'Double Horsemen embroidery: Signature branding on the chest',
      'Versatile style: Easily pairs with both casual and smart outfits',
      'Classic polo collar: Adds timeless appeal'],
    image: require('../../../image/Our_product/USP2672/USP2672-G92-MS_1.webp'),
    images: [
      require('../../../image/Our_product/USP2672/USP2672-G92-MS_1.webp'),
      require('../../../image/Our_product/USP2672/USP2672-G92-MS_2.webp'),
      require('../../../image/Our_product/USP2672/USP2672-G92-MS_3.webp'),
      require('../../../image/Our_product/USP2672/USP2672-G92-MS_4.webp'),
      require('../../../image/Our_product/USP2672/USP2672-G92-MS_5.webp'),]
  },
  {
    id: '8',
    sku: 'WUP0398-879',
    title: 'Womens Crew Neck Cable Jumper',
    description: 'Elevate your essentials with the U.S. Polo Assn. Womens Crew Neck Cable Jumper. Crafted from a soft cotton blend with a classic cable knit, this piece combines timeless style with cosy comfort. Perfectly paired with tailored trousers for a sophisticated touch or layered over jeans for effortless weekend wear.',
    category: 'Womens',
    quality: '100% Cotton',
    highlights: [
      '100% Cotton for breathable comfort',
      'Crew neck design adds a timeless silhouette',
      'Cable knit pattern for classic styling',
      'Signature branding on the chest for a refined finish'],
    image: require('../../../image/Our_product/WUP0398/WUP0398-879-MS_5.webp'),
    images: [
      require('../../../image/Our_product/WUP0398/WUP0398-879-MS_1.webp'),
      require('../../../image/Our_product/WUP0398/WUP0398-879-MS_2.webp'),
      require('../../../image/Our_product/WUP0398/WUP0398-879-MS_3.webp'),
      require('../../../image/Our_product/WUP0398/WUP0398-879-MS_4.webp'),
      require('../../../image/Our_product/WUP0398/WUP0398-879-MS_5.webp'),
      ]
  },
    {
    id: '9',
    sku: 'WUP0400-D53',
    title: 'Womens Cable Knit Cardigan in Crystal Rose',
    description: 'The U.S. Polo Assn. Womens Cable Knit Cardigan offers an elegant layer that combines timeless style with a cosy, refined design. Crafted from soft, 100% cotton, this cropped cardigan features a classic cable-knit pattern and branded horn buttons for a heritage-inspired touch. Pair with a simple tee and jeans for a polished, casual look or layer over a dress for added warmth and style.',
    category: 'Womens',
    quality: '100% Cotton',
    highlights: [
      '100% Cotton for breathable comfort',
      'Branded horn buttons – Adds a sophisticated, heritage touch',
      'Cable knit pattern for classic styling',
      'Signature branding on the chest for a refined finish'],
    image: require('../../../image/Our_product/WUP0400/WUP0400-D53-MS_1.webp'),
    images: [
      require('../../../image/Our_product/WUP0400/WUP0400-D53-MS_1.webp'),
      require('../../../image/Our_product/WUP0400/WUP0400-D53-MS_5.webp'),
      require('../../../image/Our_product/WUP0400/WUP0400-D53-MS_2.webp'),
      require('../../../image/Our_product/WUP0400/WUP0400-D53-MS_3.webp'),
      require('../../../image/Our_product/WUP0400/WUP0400-D53-MS_4.webp'),]
  },
  {
    id: '10',
    sku: 'USP2591-L45',
    title: 'Boys Knitted Funnel Neck',
    description: 'Discover timeless sophistication with the U.S. Polo Assn. Boys Knitted Funnel Neck, a wardrobe staple that effortlessly combines comfort and style. Crafted from a luxurious cotton blend, this classic fit garment features a ribbed funnel neck and cuffs for a refined touch.',
    category: 'Boys',
    quality: '60% Cotton 20% Viscose 20% Nylon',
    highlights: [
      'Luxurious cotton blend fabric',
      'Ribbed funnel neck and cuffs',
      'Functional zip front with branded USPA zip',
      'Embroidered double horsemen logo'],
    image: require('../../../image/Our_product/USP2591/USP2591-L45-MS_1.webp'),
    images: [
      require('../../../image/Our_product/USP2591/USP2591-L45-MS_1.webp'),
      require('../../../image/Our_product/USP2591/USP2591-L45-MS_2.webp'),
      require('../../../image/Our_product/USP2591/USP2591-L45-MS_3.webp'),]
  },
];

export default productsData;
